<div class="flex flex-col gap-4 px-6 py-7">
  <div class="flex items-start justify-between mb-6">
    <p class="text-2xl text-nowrap pt-1 font-bold text-sigecom-dark-gray">
      Gerenciamento de chaves
    </p>
    <div class="flex flex-wrap justify-end gap-2">
      <sigecom-button
        class="text-sigecom-info"
        title="TELA CHEIA"
        icon="expand"
        (buttonClicked)="toogleFullScreen()"
      />
    </div>
  </div>
  <div
    *ngIf="simpleStepParametrization$ | async as info"
    class="w-full"
  >
    <div
      *ngIf="bannerPreview"
      class="h-[180px] w-full overflow-hidden rounded-xl bg-white shadow-lg"
    >
      <img
        [src]="bannerPreview"
        alt="Banner da fase"
        class="h-full w-full object-cover"
      />
    </div>
    <div
      *ngIf="!bannerPreview"
      class="bg-white shadow-lg flex flex-wrap items-center justify-between gap-4 px-6 py-4 rounded-xl"
    >
      <div class="flex flex-col justify-center">
        <p class="font-bold text-lg text-sigecom-info">{{ info.petTxNome }}</p>
        <!-- <p class="text-sigecom-gray">Definição dos grupos iniciais</p> -->
      </div>
      <div class="flex gap-12 text-sigecom-gray">
        <div class="flex flex-col text-center">
          <p class="font-bold">Categoria</p>
          <p>{{ info.categoriaInfo }}</p>
        </div>
        <div class="flex flex-col text-center">
          <p class="font-bold">Formato</p>
          <p>{{ info.formatoInfo }}</p>
        </div>
        <div class="flex flex-col text-center">
          <p class="font-bold">Modalidade</p>
          <p>{{ info.modalidadeInfo }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="flex gap-4">
    <div class="rounded-xl h-fit overflow-clip">
      <div
        class="bg-white h-full max-h-[55dvh] overflow-y-scroll max-w-[40dvw] shadow-lg flex flex-col gap-4 flex-shrink-0 px-5 py-4"
      >
        <sigecom-button
          class="w-full"
          title="SORTEAR"
          type="info"
          icon="shuffle"
          (buttonClicked)="this.click$.next()"
          [disabled]="drawDisabled || !(todosCabecasSelecionados$ | async)"
        />

        <sigecom-button
          class="w-full text-sigecom-info"
          title="SORTEAR TUDO"
          icon="shuffle"
          (buttonClicked)="generalDraw()"
          [disabled]="drawDisabled || !(todosCabecasSelecionados$ | async)"
        />

        <sigecom-button
          class="w-full text-sigecom-info"
          type="danger"
          title="REINICIALIZAR SORTEIO"
          icon="refresh"
          (buttonClicked)="showConfirmationModal()"
          [disabled]="qtdIncSelecionados === 0"
        />

        <div class="flex flex-col text-center">
          <p class="text-lg font-bold text-sigecom-info">Participantes</p>
          <p class="font-bold text-sigecom-gray">
            {{ qtdIncSelecionados }}/{{ qtdTotalInc }} sorteados
          </p>
        </div>
        <sigecom-button
          *ngFor="
            let item of enrollmentStates$ | async;
            trackBy: trackStateById
          "
          class="w-full"
          [type]="item.buttonType"
          [title]="item.estTxSigla"
          class="text-wrap w-full"
        />
      </div>
    </div>

    <div
      class="bg-white shadow-lg min-h-[100%] flex-grow flex flex-col gap-2 px-5 py-4 rounded-xl"
    >
      <div
        class="w-full border border-sigecom-info py-4 text-center rounded-lg font-bold text-sigecom-info"
      >
        {{ petDescription }}
      </div>
      <div
        class="grid xl:grid-cols-8 lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-2 gap-2 text-center"
      >
        <div
          *ngFor="let item of keys$ | async; trackBy: trackClashById"
          class="bg-[#E5E7EB] col-span-1 gap-2 flex flex-col items-center justify-start pt-2 pb-4 rounded-lg"
        >
          <p class="font-bold py-1 text-sigecom-info">
            {{ item.cheTxNome }}
          </p>

          <div class="flex flex-col px-4 gap-2 w-full">
            <ng-container *ngFor="let slot of getSlots(item); let i = index">
              <ng-container
                *ngIf="item.inscricoesChave![i] as inc; else emptySlot"
              >
                <sigecom-button
                  [title]="
                    inc.estTxSigla.length > 4 && !inc.ichBlSede
                      ? inc.estTxSigla.substring(0, 5) + '...'
                      : inc.estTxSigla
                  "
                  [attr.title]="inc.estTxSigla"
                  [icon]="slot.isHead ? 'key' : undefined"
                  [type]="slot.isHead ? 'head' : 'selected'"
                  class="w-full"
                  (buttonClicked)="
                    slot.isHead
                      ? openCabecaChaveModal(
                          item.cheNrId,
                          inc.ichNrId,
                          item.cheTxNome
                        )
                      : null
                  "
                />
              </ng-container>

              <ng-template #emptySlot>
                <sigecom-button
                  title="-"
                  class="w-full"
                  [icon]="slot.isHead ? 'key' : undefined"
                  [type]="slot.isHead ? 'head' : 'void'"
                  (buttonClicked)="
                    slot.isHead
                      ? openCabecaChaveModal(
                          item.cheNrId,
                          undefined,
                          item.cheTxNome
                        )
                      : null
                  "
                />
              </ng-template>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<sigecom-action-buttons
  *ngIf="canMakeChange"
  (cancelClick)="makeChange()"
  [hideSaveButton]="true"
  class="fixed bottom-0 right-0 mr-14 mb-6"
  cancelIcon="shuffle"
  cancelTitle="Fazer Troca"
  tooltip="Troca o último participante sorteado com a primeira equipe do estado sede para resolver o conflito."
  type="danger"
/>

<sigecom-modal
  [open]="drawModalOpen"
  [showCloseButton]="false"
  [alternativeStyle]="modalStateChange"
>
  <div class="flex flex-col items-center">
    <p
      class="font-bold text-center pt-2 pb-4 text-xl text-sigecom-gray"
      [ngClass]="{ 'text-white': modalStateChange }"
    >
      {{ modalStateChange ? "SORTEADO!" : "SORTEANDO..." }}
    </p>

    <div class="flex gap-2 items-center px-4">
      <sigecom-roulette
        [isNational]="isNational"
        [open]="drawModalOpen"
        [participant]="drawedIncTemp"
        (animationEnded)="changeModalStyle()"
      />
    </div>

    <sigecom-button
      class="mt-4 shadow-none"
      [ngClass]="{ 'font-bold shadow-md': modalStateChange }"
      title="CONFIRMAR"
      [type]="modalStateChange ? 'success' : 'not-selected'"
      (buttonClicked)="closeDrawModal()"
      [disabled]="!modalStateChange"
    />
  </div>
</sigecom-modal>

<sigecom-modal
  [open]="cabecaChaveModalOpen"
  (modalStateChange)="closeModalCabecaChave()"
  class="transition-opacity"
>
  <ng-container>
    <p class="font-bold text-lg text-sigecom-info mr-20 mb-4">
      Adicionar cabeça de chave - {{ cheTxNomeModalAddCabecaChave }}
    </p>

    <div class="flex flex-col gap-2 p-5">
      <!-- BUSCA -->
      <div class="w-full pb-2 relative">
        <input
          type="text"
          placeholder="Pesquise"
          (input)="searchCabecasDeChaveByName($event)"
          class="w-full py-3 border border-[#dadada] rounded-md pl-2 outline-none focus:ring-2 focus:ring-blue-500"
        />
        <fa-icon
          [icon]="'magnifying-glass'"
          class="absolute right-3 text-sigecom-dark-gray top-1/2 -translate-y-1/2"
        >
        </fa-icon>
      </div>

      <!-- LISTA OU EMPTY -->
      <ng-container *ngIf="cabecasDeChaveList$ | async as lista">
        <ng-container *ngIf="lista.length > 0; else emptyList">
          <div
            *ngFor="let inc of lista; trackBy: trackById"
            class="w-full px-6 py-3 flex justify-between items-center bg-gray-300 rounded-lg shadow-sm"
          >
            <p class="pr-5">
              {{ getDisplayNameStateSede(inc) }}
            </p>

            <sigecom-button
              type="info"
              (buttonClicked)="
                addCabecaChave(
                  !isNational ? inc.ineNrId : inc.fedNrId,
                  inc.ichBlSede
                )
              "
              title="Adicionar cabeca de chave"
              [enableLoading]="
                submittingCabecaChave ===
                (!isNational ? inc.ineNrId : inc.fedNrId)
              "
              [disabled]="inc.ichNrId !== null"
            />
          </div>
        </ng-container>
      </ng-container>

      <!-- EMPTY -->
      <ng-template #emptyList>
        <p>Nenhuma inscrição disponível</p>
      </ng-template>
    </div>
  </ng-container>
</sigecom-modal>
